import { Button } from '@avanta/shared/components/ui/Button';
import { Checkbox } from '@avanta/shared/components/ui/Checkbox';
import { Input } from '@avanta/shared/components/ui/Input';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type OptionType } from 'types/sapa';
import { useSapaChatContext } from '../../context';
import { CSS_CLASSES, OPTION_VALUES } from '../../hooks/constants';
import { type MultipleQuestionProps } from './types';

export const MultipleQuestion = ({ message }: MultipleQuestionProps): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.SERVICES);
  const { answers, handleAnswer } = useSapaChatContext();
  const { options, questionId, hasTextInput, textInputLabel } = message;
  const [localAnswers, setLocalAnswers] = useState<string[]>([]);
  const [textInput, setTextInput] = useState<string>('');
  if (!questionId || !options) return null;
  const isAnswered = !!answers[questionId];
  const isDisabled =
    !localAnswers.length ||
    (hasTextInput && localAnswers.includes(OPTION_VALUES.NONE) && !textInput);
  const handleCheckboxChange = (option: OptionType, checked: boolean): void => {
    if (isAnswered) return;
    const { value } = option;
    if (value === OPTION_VALUES.NONE) {
      setLocalAnswers(checked ? [OPTION_VALUES.NONE] : []);
      return;
    }
    const withoutNone = localAnswers.filter(a => a !== OPTION_VALUES.NONE);
    const newAnswers = checked ? [...withoutNone, value] : withoutNone.filter(a => a !== value);
    setLocalAnswers(newAnswers);
  };
  const handleSubmit = (): void => {
    handleAnswer(questionId, localAnswers, textInput || undefined);
  };
  return (
    <div className={CSS_CLASSES.SPACE_Y_2}>
      {options.map(option => (
        <div key={option.id} className={CSS_CLASSES.CHECKBOX_CONTAINER}>
          <Checkbox
            id={option.id}
            checked={localAnswers.includes(option.value)}
            disabled={isAnswered}
            onCheckedChange={checked => handleCheckboxChange(option, checked as boolean)}
          />
          <label htmlFor={option.id} className={CSS_CLASSES.CHECKBOX_LABEL}>
            {option.text}
          </label>
        </div>
      ))}
      {hasTextInput && localAnswers.includes(OPTION_VALUES.NONE) && (
        <div className={CSS_CLASSES.TEXT_INPUT_CONTAINER}>
          <Input
            type="text"
            placeholder={textInputLabel}
            value={textInput}
            disabled={isAnswered}
            onChange={e => setTextInput(e.target.value)}
            className={CSS_CLASSES.INPUT_FULL_WIDTH}
          />
        </div>
      )}
      {!isAnswered && (
        <Button className={CSS_CLASSES.BUTTON_SUBMIT} disabled={isDisabled} onClick={handleSubmit}>
          {t('Sapa.continue.cta')}
        </Button>
      )}
    </div>
  );
};
